import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mx-3 mx-lg-0 position-relative" }
const _hoisted_2 = { class: "row overflow-hidden tabs-wrapper" }
const _hoisted_3 = {
  class: "w-100 font-size-14 d-none d-lg-flex flex-row justify-content-between align-items-around",
  ref: "packagesContainer"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-inner-wrapper" }
const _hoisted_6 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center pack-code" }
const _hoisted_8 = { class: "d-flex align-items-center" }

import {  computed, nextTick} from "vue"
import { useStore } from "vuex"
import RadioCircle from "@/vue/common/radioCircle.vue"
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"

type SwitchOption = {
	label: string
	action: () => void
	selected: boolean
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'flightSwitch',
  props: {
	packagesToDisplay: {
		type: Array,
		default: () => [],
	},
},
  setup(__props) {

const props = __props

// Store
const store = useStore()

// Computed properties
const content = computed(() => store.state.content)

// TODO will probably need to select a packCode here(transport or non)
const options = computed<SwitchOption[]>(() => {

	const isFlightPackCode = flightPackCode.includes(store.state.packCode) || trainPackCode.includes(store.state.packCode)
	const options: SwitchOption[] = [
	{
			label: content.value.flight_switch_yes,
			action: () => handleSwitch(true),
			selected: isFlightPackCode
		},
		{
			label: content.value.flight_switch_no,
			action: () => handleSwitch(false),
			selected: !isFlightPackCode
		},
	]

	return options
})

const tabWidth = computed(() => {
	return `${100 / (options.value.length || 1)}%`
})
// Methods
// const selectTransport = (select: boolean): void => {
// 	store.dispatch("selectTransportWithDefaultPackage", select)
// }
const handleSwitch = (bool: boolean) => {
	store.commit("setTransport", bool)
	store.commit("setTransportationSelected", bool)
	nextTick(() => {
		store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
		store.dispatch("selectTransportWithDefaultPackage", bool)
	})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, option_i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${option}-${option_i}`,
            style: _normalizeStyle({ width: tabWidth.value }),
            class: _normalizeClass([
						option.selected
							? 'active font-weight-700'
							: 'text-grey-900'
					, "package-tab"]),
            onClick: option.action
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(RadioCircle, {
                  active: option.selected,
                  colorDefault: 'var(--primary-blue)',
                  colorActive: 'white',
                  additionalClasses: 'me-1 me-xl-3'
                }, null, 8, ["active"])
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(option.label), 1)
              ])
            ])
          ], 14, _hoisted_4))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})